import { documentationCard } from './de/components/cards/documentationCard'
import { noteCard } from './de/components/cards/noteCard'
import { toDoCard } from './de/components/cards/toDoCard'
import { generator } from './de/components/generator/generator'
import { searchingDialog } from './de/components/generator/searchingDialog'
import { emailInput } from './de/components/inputs/emailInput'
import { fileInput } from './de/components/inputs/fileInput'
import { numberInput } from './de/components/inputs/numberInput'
import { passwordInput } from './de/components/inputs/passwordInput'
import { anchors } from './de/components/navigations/hausHeld/anchors'
import { footer } from './de/components/navigations/hausHeld/footer'
import { topNavigation } from './de/components/navigations/hausHeld/topNavigation'
import { landing, noMatchingProject, projectOverview } from './de/pages/hausheld/index'

import { navigation } from './de/components/navigations/myHausHeld/navigation'

import { projectStatus } from './de/components/status/projectStatus'
import { fatalError } from './de/fatalError'
import { global } from './de/global'
import { images } from './de/images'
import { aboutUs } from './de/pages/aboutUs'
import { wir, wirForm } from './de/pages/hausheld/wir'
import {
  analysis,
  analysisOverview,
  analysisDetailsView,
  createComponentModal,
} from './de/pages/myhausheld/analysis'

import { conditions } from './de/pages/conditions'
import { contact } from './de/pages/contact'
import { dataProtection } from './de/pages/dataProtection'
import { error } from './de/pages/error'
import { counselor } from './de/pages/hausheld/counselor'
import { partner } from './de/pages/hausheld/get-partner'
import { chooseProject } from './de/pages/hausheld/projects'
import { impressum } from './de/pages/impressum'
import { index } from './de/pages/index'
import { forgotPassword } from './de/pages/myhausheld/auth/forgotPassword'
import { login } from './de/pages/myhausheld/auth/login'
import { newPassword } from './de/pages/myhausheld/auth/newPassword'
import { passwordResetMailSent } from './de/pages/myhausheld/auth/passwordResetMailSent'
import { register } from './de/pages/myhausheld/auth/register'
import { craftsmen } from './de/pages/myhausheld/craftsmen'

import { partnership } from './de/pages/hausheld/partnership'
import { dashboard } from './de/pages/myhausheld/dashboard'

import {
  airConditioning,
  alarmSystem,
  architect,
  assembling,
  awnings,
  balcony,
  bath,
  broker,
  carpenter,
  carport,
  chargingColumn,
  chippie,
  electrician,
  facade,
  fences,
  floorer,
  garage,
  gardener,
  heating,
  kitchen,
  metalConstruction,
  painter,
  paver,
  pergola,
  railing,
  rollerBlinds,
  roofer,
  solarPlants,
  stair,
  waterConditioning,
  whirlpool,
  window,
  wintergarden,
} from './de/pages/hausheld/_craft'
import { profile } from './de/pages/myhausheld/profile'
import {
  createCraftsmanAndQuoteModal,
  createNoteModal,
  project,
} from './de/pages/myhausheld/_project'

import { createToDoModal } from './de/pages/myhausheld/createTodoModal'
import { createProject } from './de/pages/myhausheld/projectCreate'

import {
  projects,
  noProjects,
  projectsOverview,
  projectDetailsView,
} from './de/pages/myhausheld/projects'
import { realEstate } from './de/pages/myhausheld/realEstate'
import { appointment } from './de/pages/myhausheld/tools/appointment'
import { mhCounselor } from './de/pages/myhausheld/tools/counselor'
import { documents } from './de/pages/myhausheld/tools/documents'
import { finance } from './de/pages/myhausheld/tools/finance'
import { tools } from './de/pages/myhausheld/tools/tools'
import { uploadFileModal } from './de/pages/myhausheld/uploadFileModal'
import { sponsoring } from './de/pages/sponsoring'
import { thanks } from './de/pages/thanks'

import { menuListLarge } from './de/components/navigations/aufzugo/MenuListLarge'
import { aufzugoLanding } from './de/pages/aufzugo'
import { mortgage } from './de/pages/mortgage'

import { cookieConsent } from './de/components/cookieConsent/cookieConsent'
import { aufzugoAboutUs } from './de/pages/aufzugo/aboutUs'
import { aufzugoEmergencyCall } from './de/pages/aufzugo/emergencyCall'
import { aufzugoMaintenance } from './de/pages/aufzugo/maintenance'
import { aufzugoModernization } from './de/pages/aufzugo/modernization'
import { aufzugoNewConstruction } from './de/pages/aufzugo/newConstruction'
import { aufzugoGetPartner } from './de/pages/aufzugo/getPartner'
import { brokerPage } from './de/pages/satellite/broker'
import { invoice, invoiceOverview } from './de/pages/tools/invoice'
import { myHausHeldLanding } from './de/pages/myhausheld/landing'

export default {
  global,
  images,
  topNavigation,
  landing,
  footer,
  chooseProject,
  contact,
  emailInput,
  counselor,
  projectOverview,
  noMatchingProject,
  generator,
  partner,
  anchors,
  thanks,
  aboutUs,
  conditions,
  impressum,
  dataProtection,
  alarmSystem,
  airConditioning,
  assembling,
  architect,
  awnings,
  balcony,
  bath,
  broker,
  carpenter,
  carport,
  electrician,
  facade,
  fences,
  floorer,
  garage,
  gardener,
  heating,
  kitchen,
  metalConstruction,
  painter,
  paver,
  pergola,
  railing,
  rollerBlinds,
  roofer,
  stair,
  waterConditioning,
  whirlpool,
  chippie,
  solarPlants,
  window,
  wintergarden,
  error,
  searchingDialog,
  wirForm,
  wir,
  fatalError,
  chargingColumn,
  index,
  login,
  forgotPassword,
  passwordResetMailSent,
  register,
  passwordInput,
  navigation,
  projects,
  noProjects,
  projectsOverview,
  projectDetailsView,
  createProject,
  project,
  analysis,
  analysisOverview,
  analysisDetailsView,
  craftsmen,
  createToDoModal,
  toDoCard,
  tools,
  fileInput,
  dashboard,
  documentationCard,
  projectStatus,
  createComponentModal,
  createCraftsmanAndQuoteModal,
  finance,
  profile,
  realEstate,
  newPassword,
  mhCounselor,
  createNoteModal,
  noteCard,
  appointment,
  uploadFileModal,
  partnership,
  documents,
  numberInput,
  mortgage,
  sponsoring,
  menuListLarge,
  aufzugoLanding,
  aufzugoMaintenance,
  aufzugoModernization,
  aufzugoEmergencyCall,
  aufzugoNewConstruction,
  aufzugoAboutUs,
  cookieConsent,
  aufzugoGetPartner,
  brokerPage,
  invoice,
  invoiceOverview,
  myHausHeldLanding,
}
